export default __webpack_public_path__ + "static/media/img-about.438afc81.jpg";